module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABFCAMAAADEkbAlAAAAPFBMVEXVVYDRRnTbSW3YRWzXSnHZR3HaSHDZSW/aSW/dV3vfZoflgZzojqbtqLryv8z0y9X54Of76vD99ff////KUh8RAAAAE3RSTlMGCw4aLTZgqMzP0tnd5Ovu9fj89DyeggAAAIRJREFUWMPt1EsOgCAQA1D8C+IHuP9dFQ/ANOlGk/YAbzFtxnU9HeeWlc4sRIgQIUKEfAYJp6eRkEvyLJJKgZQmspeqBPImr5ID2Q6mWBVDirkTRLHHdlTl4pAtVyRSCGJYCGQYCGa0EdBoI6DRRuKzkI3+JxEy9KiFCBEiRMgfkXGiM9yCMJLakkEEIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/flick-right.png
// module id = 261
// module chunks = 0